export const environment = {
  production: false,
  TITLE: 'QA Environment Heading',
  api: '',
  APIURL: 'https://qa.sanet.tutumfsw.com',
  portAuth: 'https://qa.sanet.tutumfsw.com',
  portHospital: 'https://qa.sanet.tutumfsw.com',
  portUserAdmin: 'https://qa.sanet.tutumfsw.com',
  portGlobalCat: 'https://qa.sanet.tutumfsw.com',
  portDiagnostic: 'https://qa.sanet.tutumfsw.com',
  portDiagnosticMassive: 'https://qa.sanet.tutumfsw.com',
  portPatients: 'https://qa.sanet.tutumfsw.com',
  portSchedule: 'https://qa.sanet.tutumfsw.com',
  portConsumerKafka: 'https://qa.sanet.tutumfsw.com',
  portProducerKafka: 'https://qa.sanet.tutumfsw.com',
  portHospitalResource: 'https://qa.sanet.tutumfsw.com',
  portReports: 'https://qa.sanet.tutumfsw.com',
  portOperatingRooms: 'https://qa.sanet.tutumfsw.com', 
  portFileSystem: 'https://qa.sanet.tutumfsw.com'
};
